import { ApiConfig } from '@ajin/config/api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Credential } from './credential';

@Injectable({
	providedIn: 'root'
})
export class CredentialService {
	private _credential: Credential | null;

	constructor(private httpClient: HttpClient) {
	}

	get credential(): Credential {
		return this._credential;
	}

	load(): Observable<Credential> {
		return new Observable(observer => {
			const url = ApiConfig.url + 'credentials';
			this.httpClient.get(url).subscribe({
				next: result => {
					this._credential = (result as Credential);
					observer.next(this.credential);
					observer.complete();
				},
				error: error => {
					observer.error(error);
					observer.complete();
				}
			});
		});
	}
}
